import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface HomeActivityEmptyStateProps {
  label?: string
  sublabel: string
  aligment?: string
  showIcon?: boolean
}

const HomeActivityEmptyState: React.FC<HomeActivityEmptyStateProps> = (
  props,
) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: ${props.aligment || 'flex-start'};
        text-align: ${props.aligment || 'flex-start'};
      `}
    >
      {props.showIcon && (
        <span
          css={css`
            font-size: 60px;
            line-height: 1;
            margin: 20px 0;
          `}
        >
          {'🎉'}
        </span>
      )}
      {props.label && (
        <div
          css={css`
            margin-bottom: 8px;
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )};
          `}
        >
          <Trns source={props.label} />
        </div>
      )}
      <div
        css={css`
          ${getFontCss(
            12,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.regular,
          )};
        `}
      >
        <Trns source={props.sublabel} />
      </div>
    </div>
  )
}

export default HomeActivityEmptyState
